export interface OfferContentGeneratorRequest {
  messages: Array<{
    content: string;
    role: string;
  }>;
  temperature: number;
  stream?: boolean;
  context: OfferContentGeneratorContext;
}

export interface OfferContentGeneratorResponse {
  content: string;
}

export enum OfferContentGeneratorContext {
  Description = 'description',
  Requirements = 'requirements',
}

export type OfferContentByChunkResponse<TDataResponse> = {
  type: 'progress' | 'load';
  message: TDataResponse;
};
